const article = {
  title: '彩票资讯',
  subtitle: '掌握行业动态，了解最新玩法攻略与中奖故事',
  backToList: '返回资讯列表',
  publishedAt: '发布时间',
  author: '作者',
  source: '来源',
  category: '分类',
  relatedArticles: '相关文章',
  prevArticle: '上一篇',
  nextArticle: '下一篇',
  shareTitle: '分享文章',
};

export default article;